import { useEffect, useState } from "react";
import { errorMessage, request } from "../lib/api";
import type { Me } from "../types";

export interface ProfileState {
  me: Me | null;
  loading: boolean;
  error: string;
}

export function useProfile(): ProfileState {
  const [state, setState] = useState<ProfileState>({ me: null, loading: true, error: "" });

  useEffect(() => {
    request<Me>("/api/me")
      .then((me) => setState({ me, loading: false, error: "" }))
      .catch((cause) =>
        setState((current) => ({ ...current, loading: false, error: errorMessage(cause) }))
      );
  }, []);

  return state;
}
